import { defaultDataIdFromObject } from '@apollo/client'
import type { KeyFieldsFunction } from '@apollo/client/cache/inmemory/policies'

export const dataIdFromObject: KeyFieldsFunction = responseObject => {
  switch (responseObject.__typename) {
    case 'Book':
      return `Book:${responseObject.slug}`
    case 'BookAsNode':
      return `BookAsNode:${responseObject.slug}`
    default:
      return defaultDataIdFromObject(responseObject)
  }
}
